import { Injectable } from '@angular/core';
import { FeatureFlagsRulesServiceBase } from '@skylab-shared/core';
import { Wrapper } from '../wrapper/wrapper';

@Injectable({providedIn: 'root'})
@Wrapper(FeatureFlagsRulesServiceBase)
export class FeatureFlagsRulesService { }
